<div class="form-group mt-4">
  <div class="tw-flex tw-items-center">
    <div
      class="tw-w-1/2 tw-flex tw-gap-4 xl:!tw-items-center tw-flex-col xl:!tw-flex-row"
    >
      <label
        id="overrideLabel"
        class="tw-text-gray-700 tw-font-bold tw-mb-0 tw-w-36 tw-mr-4"
        >Override</label
      >
      <mat-form-field
        class="tw-w-1/2"
        [ngClass]="{
          'None-selected': scheduleType === 'default',
          'Replace-selected': scheduleType === 'override_replace',
          'Include-selected': scheduleType === 'override_insert',
        }"
        appearance="outline"
        subscriptSizing="dynamic"
      >
        <mat-select
          [(ngModel)]="scheduleType"
          (selectionChange)="detectChanges()"
          [disabled]="!isOverrideAvailable"
          [panelWidth]="'300px'"
          class="tw-w-full"
          [panelClass]="'!tw-h-auto !tw-max-h-none !tw-rounded-xl tw-overflow-hidden'"
          [hideSingleSelectionIndicator]="true"
          aria-labelledby="overrideLabel"
        >
          <mat-select-trigger>
            @if (scheduleType === 'default') {
              <span class="tw-ml-[16px] tw-text-gray-700">None</span>
            }
            @if (scheduleType === 'override_replace') {
              <span
                class="tw-inline-flex tw-items-center tw-gap-[8px] tw-pl-[16px] tw-text-yellow-700"
              >
                <mat-icon svgIcon="switch" class="small" />
                Replace
              </span>
            }
            @if (scheduleType === 'override_insert') {
              <span
                class="tw-inline-flex tw-items-center tw-gap-[8px] tw-pl-[16px] tw-text-blue-700"
              >
                <mat-icon svgIcon="square-check" class="small" />
                Include
              </span>
            }
          </mat-select-trigger>
          <div role="radiogroup" aria-labelledby="overrideLabel">
            <mat-option value="default">
              <div class="tw-flex tw-items-center tw-gap-3">
                <mat-radio-button
                  [checked]="scheduleType === 'default'"
                  class="!tw-m-0"
                  aria-labelledby="defaultOptionLabel"
                ></mat-radio-button>
                <span id="defaultOptionLabel"
                  ><schedule-type-pill
                    scheduleTypeName="None"
                  ></schedule-type-pill
                ></span>
              </div>
            </mat-option>
            <p class="tw-text-gray-600 tw-pl-24 tw-m-0 tw-mb-6">
              This schedule is the default display content.
            </p>
            <mat-option
              value="override_replace"
              [disabled]="!isOverrideAvailable"
            >
              <div class="tw-flex tw-items-center tw-gap-3">
                <mat-radio-button
                  [checked]="scheduleType === 'override_replace'"
                  class="!tw-m-0"
                  aria-labelledby="replaceOptionLabel"
                ></mat-radio-button>
                <span id="replaceOptionLabel"
                  ><schedule-type-pill
                    scheduleTypeName="Replace"
                  ></schedule-type-pill
                ></span>
              </div>
            </mat-option>
            <p class="tw-text-gray-600 tw-pl-24 tw-m-0 tw-mb-6">
              This schedule will replace the default display content.
            </p>
            <mat-option
              value="override_insert"
              [disabled]="!isOverrideAvailable"
            >
              <div class="tw-flex tw-items-center tw-gap-3">
                <mat-radio-button
                  [checked]="scheduleType === 'override_insert'"
                  class="!tw-m-0"
                  aria-labelledby="includeOptionLabel"
                ></mat-radio-button>
                <span id="includeOptionLabel"
                  ><schedule-type-pill
                    scheduleTypeName="Include"
                  ></schedule-type-pill
                ></span>
              </div>
            </mat-option>
            <p class="tw-text-gray-600 tw-pl-24 tw-m-0 tw-mb-6">
              This schedule will be included with the default display content.
            </p>
          </div>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="schedule-type-value" [shown]="readonly">
      <span>{{ description }}</span>
    </div>
    <div
      class="tw-flex tw-gap-6 tw-flex-col xl:!tw-flex-row"
      [shown]="!readonly"
    >
      <div
        class="tw-text-gray-500 tw-w-full tw-break-words"
        [shown]="isOverrideAvailable"
      >
        <span [shown]="scheduleType === 'default'">
          This schedule is the default display content.
        </span>
        <span [shown]="scheduleType === 'override_insert'">
          This schedule will be included with the default display content.
        </span>
        <span [shown]="scheduleType === 'override_replace'">
          This schedule will replace the default display content.
        </span>
      </div>
      <div
        class="flex-row w-100 mt-2"
        [shown]="scheduleType === 'override_replace'"
        *requireRole="'sa'"
      >
        <mat-checkbox
          checkboxId="schedule-play-once"
          [(ngModel)]="playOnce"
          ngDefaultControl
          (ngModelChange)="detectChanges()"
          [disabled]="!isOverrideAvailable"
        ></mat-checkbox>
        <label
          for="schedule-play-once"
          class="rise-admin-only control-label-secondary"
          >Play once</label
        >
      </div>
    </div>
    <div class="schedule-type-value mt-2" [shown]="!isOverrideAvailable">
      <span [shown]="isOverrideAvailable === null">
        Schedule Override feature requires an active subscription.
        <a class="madero-link" href="#" uiSref="apps.purchase.home"
          >Subscribe Now</a
        >
      </span>
      <span [shown]="isOverrideAvailable !== null">
        Schedule Override feature requires a plan upgrade.
        <a class="madero-link" actionLink (click)="showUpgradePlanModal()"
          >Upgrade Plan</a
        >
      </span>
    </div>
  </div>
</div>
